var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("survey.group.approval.model.approvalGroup")))
        ]),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            options: _vm.approvalGroups,
            label: "name",
            reduce: e => e.id,
            clearable: false
          },
          model: {
            value: _vm.approval.approvalGroupId,
            callback: function($$v) {
              _vm.$set(_vm.approval, "approvalGroupId", $$v)
            },
            expression: "approval.approvalGroupId"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    !_vm.hideApprovalStatus
      ? _c("div", { staticClass: "form-group" }, [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("survey.group.approval.model.approvalState")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.approval.approvalState === _vm.ApprovalState.Unknown
                ? _c("span", [_c("i", { staticClass: "fa fa-question" })])
                : _vm.approval.approvalState === _vm.ApprovalState.Approved
                ? _c("span", { staticClass: "text-success" }, [
                    _c("i", { staticClass: "fa fa-check" })
                  ])
                : _vm.approval.approvalState === _vm.ApprovalState.Rejected
                ? _c("span", { staticClass: "text-danger" }, [
                    _c("i", { staticClass: "fa fa-times" })
                  ])
                : _vm.approval.approvalState === _vm.ApprovalState.NotRequired
                ? _c("span", [_c("i", { staticClass: "fa fa-minus" })])
                : _c("span", [_vm._v("???")]),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "survey.group.approvalStates." +
                        _vm.camelCase(
                          _vm.ApprovalState[_vm.approval.approvalState]
                        )
                    )
                  ) +
                  "\n      "
              ),
              _vm.approvedByContact
                ? [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          " - " +
                            (_vm.approvedByContact.firstName || "") +
                            " " +
                            (_vm.approvedByContact.lastName || "") +
                            " - " +
                            _vm.formatDateTime(_vm.approval.approvedAt)
                        ) +
                        "\n      "
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }